export default {"src":"/_next/static/media/blackCheckmark_24.9831ee96.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};